// extracted by mini-css-extract-plugin
module.exports = {"divider":"Local_divider__wXBjr","divTitle":"Local_divTitle__1BiFp","nombreLocal":"Local_nombreLocal__327ok"};